"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _services = require("../../../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BroadbandCardHeader = function BroadbandCardHeader(_ref) {
  var broadband = _ref.broadband,
    isAdditionalBroadband = _ref.isAdditionalBroadband;
  var price = broadband.selectedVariant.price.priceValue;
  var discount = broadband.selectedVariant.price.discount;
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    columns: {
      sm: 2
    },
    layout: isAdditionalBroadband ? {
      sm: [8, 4]
    } : {
      sm: [8, 4]
    },
    spacing: 3,
    verticalAlign: "top",
    justify: "right"
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: "recommendation-broadband-name"
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 1,
    level: 2,
    justify: "left",
    text: {
      main: broadband.productName,
      suffix: broadband.productDescription
    }
  })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.TextStack, {
    size: 3,
    level: 2,
    justify: "right",
    text: {
      prefix: _services.locale.localeString('Recommendation.StickyFooterMonthly'),
      main: _services.locale.formatPrice(price),
      suffix: discount && "Additional discount of ".concat(_services.locale.formatPrice(discount), " with Vodafone mobile")
    }
  })));
};
var _default = BroadbandCardHeader;
exports.default = _default;